import * as React from 'react';

import {useMutation} from '@apollo/react-hooks';

import type {
    MarkNotificationRead as MarkReadMutation,
    MarkNotificationReadVariables as MarkReadVariables,
    MarkNotificationAllRead as MarkAllReadMutation,
} from 'nutshell-graphql-types';

import {nutApolloClient} from '../../../../apollo-client';

import NOTIFICATION_FRAGMENT from '../fragments/notification-fragment.graphql';
import MarkNotificationAllRead from '../mutations/mark-notification-all-read.graphql';
import MarkNotificationRead from '../mutations/mark-notification-read.graphql';

type Props = {
    children: (arg1: {
        onMarkRead: (notificationId: string, queryVariables?: MarkReadVariables) => Promise<any>;
        onMarkAllRead: () => Promise<any>;
    }) => React.ReactElement;
};

export function NotificationsMutations(props: Props) {
    const [markRead] = useMutation<MarkReadMutation, MarkReadVariables>(MarkNotificationRead);
    const [markAllRead] = useMutation<MarkAllReadMutation, null>(MarkNotificationAllRead);

    return props.children({
        onMarkRead: (notificationId: string) => {
            return markRead({
                variables: {
                    id: notificationId,
                },
                // @ts-expect-error
                optimisticResponse: () => {
                    const notificationFragment = nutApolloClient.readFragment({
                        id: notificationId,
                        fragmentName: 'NotificationFragment',
                        fragment: NOTIFICATION_FRAGMENT,
                    });

                    if (notificationFragment) {
                        return {
                            notificationMarkRead: {
                                __typename: 'NotificationMarkReadPayload',
                                notification: {
                                    ...notificationFragment,
                                    readStatus: 'READ',
                                },
                            },
                        };
                    }
                },
            });
        },
        onMarkAllRead: () => {
            return markAllRead();
        },
    });
}
